
const encSecret =  {
    key : "asdfghjqwertyuzxcvbn98765432"
}

export default encSecret;